import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { WarrantyErrorInfo } from '../fragments';

export default gql`
  mutation updateWarrantyError($input: WarrantyErrorUpdateInput!) {
    updateWarrantyError(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      warrantyError {
        ...WarrantyErrorInfo
      }
    }
  }
  ${WarrantyErrorInfo}
  ${ErrorMessageInfo}
`;
